import { UICorePlugin } from "../../../../lib/Plugin";
import { unPackAction } from './unpackAction';
import { placeCompInsideAction } from './placeCompInsideActions';
import { zoomAction } from "../../../../lib/builtin/plugins/CompActions/zoomAction";
import { setCompIdAction } from "../../../../lib/builtin/plugins/CompActions/setCompIdAction";
import { copyAction } from "../../../../lib/builtin/plugins/CompActions/copyAction";
// action只会越来越多 从designer里拖出来
const ActionHooks = {
  unPackAction,
  placeCompInsideAction,
  setCompIdAction,
  zoomAction,
  copyAction
};
export class CompActionsPlugin extends UICorePlugin {
  install(uc) {
    Object.entries(ActionHooks).forEach(([key, value]) => {
      uc.hooks.getActionsOfComponent.tap(key, (list, ctx) => {
        try {
          return value(list, ctx);
        } catch (e) {
          return list;
        }
      });
    });
  }
}